/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DetailsRequest {
    getFixupPrototypeFunction() { return DetailsRequest.fixupPrototype; }

    static newInstance(model: Partial<DetailsRequest>): DetailsRequest {
        let obj = Object.assign(new DetailsRequest(), model);
        DetailsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DetailsRequest>): DetailsRequest {
        if (!model) return null;
        return DetailsRequest.newInstance(<DetailsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DetailsRequest) {
        if (!obj) return;

        models.DetailsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DetailsRequest): boolean {
        Object.setPrototypeOf(obj, DetailsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant to filter the violation detail. Please get tenant_id from cloud_accounts of AccessVisibilityFilters in Access Visibility Dashboard
     */
    tenant_id: string;

    /**
     * ID of the cloud account to filter the violation detail. Please get cloud_account_id from cloud_accounts of AccessVisibilityFilters in Access Visibility Dashboard
     */
    cloud_account_id: string;

    /**
     * To get violations from all the tenants, please give Yes. If selected No, then it is mandatory to provide tenant_id and cloud_account_id
     */
    all_tenants: models.YesNo;

    /**
     * Search by account_name wise
     */
    search: string;

}
